import React, { useEffect, useState } from "react";
import i18next from "i18next";
import Constants from "../../Constants";
import { FileAttachmentIconICR, MinusCircleIconICR, PlusCircleIconICR } from "../../AppIcons";
import APIUrls from "../../services/APIUrls";
import axios from "axios";
import jQuery from "jquery";
import { useNavigate } from "react-router-dom";
import { getAxiosResponse, logError, postAxiosResponse } from "../../services/authApiRoutes/APImethods";
import CustomProgressBar from "../global/CustomProgressBar";
import { useTranslation } from "react-i18next";
import { getAssigneeForPhase, getNextReviewPhaseInStepIfExists, getNextWorkPhaseIfExists } from "../../services/WorkflowUtils";

const chunkSize = Constants.CHUNK_SIZE;

export default function ApproveAssetPopup(prop) {

    const { t } = useTranslation();
    const navigate = useNavigate();

    const [active, showActive] = useState(false);
    const [selectedfile, setSelectedFile] = useState("");
    const [showProgress, setShowProgress] = useState(false);
    const [documentFileId, setDocumentFileId] = useState(-1);
    const [currentChunkIndex, setCurrentChunkIndex] = useState(-1);
    const [approvalFeedback, setApprovalFeedback] = useState("");
    const [fileUploadProgress, setFileUploadProgress] = useState(0);
    const [helpText, setHelpText] = useState(i18next.t('icr.approve_popup_help_text', { 0: prop.targetLanguage?.display}));
    const [notesText, setNotesText] = useState(t("icr.add_vendor_notes_label"));
    const [disableCancel, setDisableCancel] = useState(false);
    const [disableSubmit, setDisableSubmit] = useState(false);

    const getCompleteReviewMessage = () => {
        const messages = [];
        if (prop.commentedThisRevisionCount === 0 && prop.uncommittedEditsCount === 0) {
          messages.push(i18next.t('icr.no_changes_message', { 0: prop.targetLanguage?.display, 1: prop.targetAssetData.current.name}));
        }
        if (prop.uncommittedEditsCount > 0) {
           messages.push(i18next.t('icr.uncommitted_edits_message', { 0: prop.uncommittedEditsCount}));
        }
        if (prop.commentedThisRevisionCount > 0) {
          messages.push(i18next.t('icr.feedback_message', { 0: prop.commentedThisRevisionCount}));
        }
        return messages;
    };

    const enabledWorkflowKeydown = (event) => {
        if (event.key===Constants.ENTER) {
            showActive(!active);
        }
    }
    
    function fileSelection(e) {
        if (e.target?.files?.length > 0) {
            setSelectedFile(e.target.files[0]);
        }
    }

    useEffect(() => {
        if (currentChunkIndex !== -1) {
          readAndUploadCurrentChunkFile();
        }
    }, [currentChunkIndex]);

    useEffect(() => {
        getAxiosResponse(APIUrls.EXISTING_PROJECT_WORKFLOW(prop.projectId, prop.workflowStatus))
            .then((res)=> {
                var existingWorkflow = res.data.data;
                for(var workflow in existingWorkflow) {
                    if(existingWorkflow[workflow].displayName[0].code === prop.languageCode){
                        const workflowResource = existingWorkflow[workflow];
                        if(workflowResource){
                            let nextReviewPhaseInStep = getNextReviewPhaseInStepIfExists(prop.targetAssetData.current.currentPhaseId, workflowResource);
                            let nextWorkPhase = getNextWorkPhaseIfExists(workflowResource, prop.targetAssetData.current.currentPhaseId);
                            setHelpText(i18next.t('icr.approve_popup_help_text', { 0: prop.targetLanguage?.display}));
                            if(nextReviewPhaseInStep != null) {
                                var assignee = getAssigneeForPhase(nextReviewPhaseInStep);
                                if(assignee && (assignee.trim() !== "")) {
                                    setHelpText(helpText + " " + i18next.t('icr.workflow_help_text_next_review_phase_in_step', { 0: assignee}));
                                }
                            } else if (nextWorkPhase != null) {
                                var assignee = getAssigneeForPhase(nextWorkPhase);
                                if(assignee && (assignee.trim() !== "")) {
                                    setHelpText(helpText + " " + i18next.t('icr.workflow_help_text_next_work_phase', { 0: assignee}));
                                }
                            }
                            setNotesText(t("icr.add_vendor_notes_label"));
                            if((nextWorkPhase === null) && (nextReviewPhaseInStep === null)) {
                                setNotesText(t("icr.add_vendor_notes_label"));
                            } else {
                                setNotesText(t("icr.add_notes_label"));
                            }
                        }
                    }
                }
            })
    }, []);

    const readAndUploadCurrentChunkFile = () => {
        const file = selectedfile;
        if (file) {
            const reader = new FileReader();
            const from = currentChunkIndex * chunkSize;
            const to = from + chunkSize;
            const blob = file.slice(from, to);
            reader.onload = (e) => uploadChunkFile(e);
            reader.readAsDataURL(blob);
            } else {
            uploadChunkFile(null);
        }
    };

    const getAttachmentParams = () => {
        let params = new URLSearchParams();
        params.set("approveWithChanges", "false");
        params.set("documentFileId", (documentFileId !== -1) ? documentFileId : "");
        params.set("ratingValue", "0");
        params.set("hasDocument", selectedfile ? "true" : "false");
        params.set("feedbackNotes", approvalFeedback ? approvalFeedback : "");
        if (selectedfile) {
            params.set("name", selectedfile.name);
            params.set("size", selectedfile.size);
            params.set("currentChunkIndex", currentChunkIndex);
            params.set("totalChunks", Math.ceil(selectedfile.size / chunkSize));
        }
        return params;
    };

    const uploadChunkFile = (readerEvent) => {
        const data = readerEvent ? readerEvent.target.result : {};
        const headers = {
          "Content-Type": "application/octet-stream",
          "CSRF-Token": localStorage.getItem("csrfToken"),
        };
        const params = getAttachmentParams();
        const urlPart = (selectedfile ? "/upload" : "") + APIUrls.CUSTOMER_PROJECT_ASSET_FEEDBACK(prop.projectId, prop.targetAssetData.current.id) + ".htm?" + params.toString();
        const url = `${process.env.REACT_APP_BACKEND_SERVER}${urlPart}`;
        axios.post(url, data, { headers }).then((response) => {
        if (response?.data?.code === 200) {
          if (selectedfile) {
            const filesize = selectedfile.size;
            const chunks = Math.ceil(filesize / chunkSize) - 1;
            const isLastChunk = currentChunkIndex === chunks;
            if (isLastChunk) {
                setFileUploadProgress(100);
                setCurrentChunkIndex(-1);
                setSelectedFile("");
                jQuery("body").removeClass("modal-open-10");  
                navigate(`/project/${prop.projectId}`,{state:{langCode:prop.languageCode}})
            } else {
                const chunks = Math.ceil(filesize / chunkSize);
                setFileUploadProgress(Math.round((currentChunkIndex / chunks) * 100));
                setCurrentChunkIndex(currentChunkIndex + 1);
            }
          } else {
            setCurrentChunkIndex(-1);
            setSelectedFile("");
            jQuery("body").removeClass("modal-open-10");  
            navigate(`/project/${prop.projectId}`,{state:{langCode:prop.languageCode}})
          }
        }
      });
    };
    
    const getJsonParams = () => {
        let params = {
            "approveWithChanges": "false",
            "documentFileId": (documentFileId !== -1) ? documentFileId : null,
            "ratingValue": null,
            "feedbackNotes": null,
            "childAssetIds": [],
            "hasDocument": selectedfile ? "true" : "false",
            "language": prop.targetLanguage?.language,
            "rating": {},
            "feedback": approvalFeedback,
        };
        return params;
    }

    const approveAsset = async () => {
        try {
            const params = getJsonParams();
            const response = await postAxiosResponse(APIUrls.CUSTOMER_PROJECT_ASSET_FEEDBACK(prop.projectId, prop.targetAssetData.current.id)+`.json`, params);
            if (response?.data?.data?.documentFileId) {
                setDocumentFileId(response?.data?.data?.documentFileId);
                setShowProgress(true);
            } else {
                setShowProgress(false);
            }
            setDisableCancel(true);
            jQuery(".cancelApprove").addClass("locked");
            setDisableSubmit(true);
            jQuery(".submitApprove").addClass("locked");
            if(selectedfile) {
                jQuery(".file-input").addClass("hide");
            }
            setCurrentChunkIndex(0);
        } catch (error) {
            logError("Error while approving asset : ", error);   
        }
    }

    const hideKeyDeleteflow = (event) => {
        if (event.key === Constants.ENTER) {
            prop.showActionDropdown(false)
            jQuery("body").removeClass("modal-open-10")
        }
    };

    const handleKeyDeleteflow = (event) => {
        if (event.key === Constants.TAB) {
          if (event.shiftKey === false) {
            event.preventDefault();
            jQuery(".first-focus").trigger("focus");
          }
        }
    };

    const handleCancel = () => {
        jQuery("body").removeClass("modal-open-10");
        setSelectedFile("");
        setApprovalFeedback("");
        showActive(false);
    }

    return (
        <div id="modal-open-10" className='lightbox-panel' aria-labelledby="removelabel" aria-modal="true" role="dialog">
            <div className="inner-lightbox-panel pb-0">
                <div className="modal-header flex padd-lr">
                    <h5 id="removelabel">Submit Review</h5>
                </div>
                <div className="lightbox-content padd-22 overflow-icr-approve">
                    <p className="f16-para-icr">
                        {helpText}
                    </p>
                    {getCompleteReviewMessage().map((message, index) => (
                        <p className="f16-para-icr mb-0" key={index}>
                        {message}
                        </p>
                    ))}
                    <div className={active ? "integration-accordion-list-icr open mar-top15" : "integration-accordion-list-icr mar-top15"}>
                        <div className="accordion-heading-icr flex" onClick={() => showActive(!active)}>
                            <div className="right" onKeyDown={(e) => enabledWorkflowKeydown(e)} tabIndex="0">
                                {PlusCircleIconICR}
                                {MinusCircleIconICR}
                            </div>
                            <div className="left">
                                <p className="f16-para-icr">{notesText}</p>
                            </div>
                        </div>
                        <div className="integration-accordion-content-icr flex">
                            <div className="flex wrap-dropdown wrap-dropdown-gap mb-0">
                                <div className="global-dropdown-block flex-center notes-icr pl-0 icr-notes-margin">
                                    <label>
                                    Notes <span>{1000 - (approvalFeedback?.length ? approvalFeedback?.length : 0)} characters left</span>
                                    </label>
                                    <textarea value={approvalFeedback} maxLength='1000' className="textarea" placeholder="Add notes to view in discussions." onChange={event => setApprovalFeedback(event.target.value)}></textarea>
                                </div>
                                <div className="global-dropdown-block flex-center w-d100 mar-bot10 pl-0">
                                    <div className={ selectedfile ? "uploading-files-block uploading-success max-w524 mar-top6" : "uploading-files-block uploading-success max-w524 mar-top6 hide"}>
                                        <div className="uploading-file-list flex last-row mb-0 pb-0 file-upload-approve-icr">
                                            <div className="left-file-desc flex-center chat-icon file-upload-approve-icr">
                                                <div className="file-upload-inner-div">
                                                    {FileAttachmentIconICR}
                                                </div>
                                                <div className="file-text font90 file-text-icr">
                                                    <span className="ext-name-icr flex">
                                                        <span className="file-name-icr">
                                                            {selectedfile?.name}
                                                        </span>
                                                        {selectedfile && !showProgress && (
                                                            <span className="ml-5 file-replace-link">
                                                                <label htmlFor="files" className="file-button-icr flex-center">
                                                                    (or select to replace)
                                                                </label>
                                                            </span>
                                                        )}
                                                    </span>
                                                    <div className="file-input flex hide">
                                                        <div className="input-file mb-0">
                                                            <input type="file" id="files" onChange={fileSelection} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={ showProgress ? "right-progressbar" : "right-progressbar hide" }>
                                            <CustomProgressBar
                                                completed={fileUploadProgress}
                                                labelLineHeight="1px"
                                                labelSize="14px"
                                                width="100%"
                                                labelClassName="progressBarLabel"
                                                borderRadius="30px"
                                                labelAlignment="outside"
                                                labelColor="rgba(0,0,0,0.87)"
                                                height="10px"
                                                className="file_upload_progress"
                                                bgColor="#06B878"
                                                baseBgColor="#D1DEF0"
                                                ariaValuetext={fileUploadProgress}
                                                aria-label=""
                                                aria-valuenow={fileUploadProgress}
                                            />
                                        </div>
                                    </div>
                                    {!selectedfile && !showProgress && (
                                        <div className="file-input flex">
                                            <div className="input-file mb-0">
                                                <input type="file" id="files" onChange={fileSelection} />
                                                <label className="file-button-icr flex-center" htmlFor="files">
                                                    Attach a file (Optional)
                                                </label>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>	
                <div className="modal-footer modal-footer-border flex px-22">
                    <button className="btn btn-bold first-focus cancelApprove" disabled={disableCancel} onKeyDown={hideKeyDeleteflow} onClick={handleCancel}>Cancel</button>
                    <button className="btn btn-bold active lastClick submitApprove" disabled={disableSubmit} onKeyDown={handleKeyDeleteflow} onClick={approveAsset}>Submit</button>
                </div>
            </div>		
        </div> 
    )

}